import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import * as FiIcons from 'react-icons/fi'
import SafeIcon from '../common/SafeIcon'

const { FiSearch, FiInfo } = FiIcons

const SearchForm = () => {
  const [lotNumber, setLotNumber] = useState('')
  const [isSearching, setIsSearching] = useState(false)
  const navigate = useNavigate()

  const handleSubmit = async (e) => {
    e.preventDefault()
    if (!lotNumber.trim()) return

    setIsSearching(true)
    
    // Simulate search delay
    setTimeout(() => {
      navigate(`/certificate/${encodeURIComponent(lotNumber.trim())}`)
      setIsSearching(false)
    }, 500)
  }

  return (
    <div className="max-w-2xl mx-auto">
      <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-8">
        <div className="text-center mb-8">
          <h2 className="text-2xl font-semibold text-gray-900 mb-3 font-inter">
            Certificate Lookup
          </h2>
          <p className="text-gray-600 leading-relaxed">
            Enter your product's lot number to access the Certificate of Analysis (COA) 
            and verify product quality and safety testing results.
          </p>
        </div>

        <form onSubmit={handleSubmit} className="space-y-6">
          <div>
            <label htmlFor="lotNumber" className="block text-sm font-medium text-gray-700 mb-2">
              Lot Number
            </label>
            <div className="relative">
              <input
                type="text"
                id="lotNumber"
                value={lotNumber}
                onChange={(e) => setLotNumber(e.target.value)}
                placeholder="Enter lot number (e.g., MOR2024-001, LOT-ABC123)"
                className="w-full px-4 py-3 pr-12 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-primary-500 transition-colors font-inter"
                required
              />
              <SafeIcon 
                icon={FiSearch} 
                className="absolute right-4 top-1/2 transform -translate-y-1/2 text-gray-400" 
              />
            </div>
          </div>

          <button
            type="submit"
            disabled={isSearching || !lotNumber.trim()}
            className="w-full bg-primary-600 text-white py-3 px-6 rounded-lg font-medium hover:bg-primary-700 focus:ring-2 focus:ring-primary-500 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed transition-colors font-inter"
          >
            {isSearching ? 'Searching...' : 'Search Certificate'}
          </button>
        </form>

        <div className="mt-8 p-4 bg-gray-50 rounded-lg border border-gray-200">
          <div className="flex items-start space-x-3">
            <SafeIcon icon={FiInfo} className="text-primary-600 mt-0.5 flex-shrink-0" />
            <div className="text-sm text-gray-600">
              <p className="font-medium text-gray-900 mb-1">Where to find your lot number:</p>
              <ul className="space-y-1 text-gray-600">
                <li>• Check the product label on your package</li>
                <li>• Look for "LOT:" or "Batch:" followed by numbers/letters</li>
                <li>• Usually located near the expiration date</li>
                <li>• Contact support@moringapowder.com if you need assistance</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default SearchForm